import type { ICategory } from '../../IItem'

export const getCategoryId = (
  level: number,
  category?: ICategory,
  depth = 1
): string => {
  if (!category) {
    return ''
  }
  if (level === 1) {
    return category ? category.id : ''
  }
  if (level === depth) {
    return category.id
  }
  return category.category && category.category.length > 0
    ? getCategoryId(level, category.category[0], depth + 1)
    : ''
}

export const getIsValidCategoryLevel = (
  level: number,
  category?: ICategory,
  depth = 1
): boolean => {
  if (!category) return false

  if (level === 1 || level === depth) {
    return category.name !== '' || category.isLastCategoryLevel
  }

  if (!category.category || category.category?.length === 0) return false

  return getIsValidCategoryLevel(level, category.category[0], depth + 1)
}

export const getNewItemCategoryObject = (
  itemCategory: ICategory | undefined,
  chosenCategory: ICategory,
  level: number
): ICategory => {
  const cleanedCategory = { ...chosenCategory }
  delete cleanedCategory['category']

  if (!itemCategory || level === 1) return cleanedCategory

  const subCategory = getNewItemCategoryObject(
    itemCategory.category?.[0],
    chosenCategory,
    level - 1
  )

  return {
    ...itemCategory,
    category: [subCategory],
  }
}
